/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export default function Photos() {
  return (
    <>
      <div
        className="tab-pane fade active show"
        id="nav-design"
        role="tabpanel"
        aria-labelledby="nav-design-tab"
        tabIndex={0}
      >
        <div className="row">
          <div className="productdetails-tabs mb-50">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-12">
                <div className="col-xl-12 col-lg-12 col-md-6">
                  <div className="heading">
                    <p>Photos</p>
                  </div>
                </div>
                <div className="product-additional-tab">
                  <div className="pro-details-nav mb-40">
                    <ul
                      className="nav nav-tabs pro-details-nav-btn"
                      id="myTabs"
                      role="tablist"
                    >
                      <li className="nav-item mr-20" role="presentation">
                        <button
                          className="nav-links active"
                          id="information-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#additional-information"
                          type="button"
                          role="tab"
                          aria-controls="additional-information"
                          aria-selected="false"
                          tabIndex={-1}
                        >
                          <span>All Photos</span>
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-links "
                          id="reviews-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#reviews"
                          type="button"
                          role="tab"
                          aria-controls="reviews"
                          aria-selected="true"
                        >
                          <span>Draft Photos</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                  {/* tab-content */}
                  <div className="tp-content-tab" id="myTabContent-2">
                    <div
                      className="tab-pane fade active show"
                      id="additional-information"
                      role="tabpanel"
                      aria-labelledby="    information-tab"
                    >
                      <div className="product-details-review">
                        <div className="latest-comments mb-40">
                          <ul>
                            <li>
                              <div className="comments-box d-flex align-items-center row">
                                <div className="col-xl-8 col-lg-12 col-12">
                                  <div className="comments-avatar  d-flex justify-content-between">
                                    <img
                                      src="assets/img/breadcrumb/Rectangle 3.png"
                                      alt=""
                                    />
                                    <div className="avatar-name ml-10">
                                      <b>GIFT FRAME NAME </b>
                                      <div className="comments-date mb-10">
                                        <span>16"X20" | $72.00</span>
                                      </div>
                                      <p className="mb">
                                        Lorem ipsum dolor sit amet, consectetur
                                        adipiscing <br /> elit. Etiam ipsum
                                        ante, maximus in tempor eget.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-lg-12 col-12 tablet">
                                  <div className="comments-text">
                                    <div className="comments-top d-sm-flex align-items-center justify-content-between mb-5">
                                      <div className="user-rating">
                                        <a
                                          className="recover large head"
                                          href="#"
                                        >
                                          Reorder
                                        </a>
                                        <a
                                          className="delete large head"
                                          href="#"
                                        >
                                          Delete
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li>
                              <div className="comments-box d-flex align-items-center row">
                                <div className="col-xl-8 col-lg-12 col-12">
                                  <div className="comments-avatar  d-flex justify-content-between">
                                    <img
                                      src="assets/img/breadcrumb/Rectangle 3.png"
                                      alt=""
                                    />
                                    <div className="avatar-name ml-10">
                                      <b>GIFT FRAME NAME </b>
                                      <div className="comments-date mb-10">
                                        <span>16"X20" | $72.00</span>
                                      </div>
                                      <p className="mb">
                                        Lorem ipsum dolor sit amet, consectetur
                                        adipiscing <br /> elit. Etiam ipsum
                                        ante, maximus in tempor eget.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-lg-12 col-12 tablet">
                                  <div className="comments-text">
                                    <div className="comments-top d-sm-flex align-items-center justify-content-between mb-5">
                                      <div className="user-rating">
                                        <a
                                          className="recover large head"
                                          href="#"
                                        >
                                          Reorder
                                        </a>
                                        <a
                                          className="delete large head"
                                          href="#"
                                        >
                                          Delete
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li>
                              <div className="comments-box d-flex align-items-center row">
                                <div className="col-xl-8 col-lg-12 col-12">
                                  <div className="comments-avatar  d-flex justify-content-between">
                                    <img
                                      src="assets/img/breadcrumb/Rectangle 3.png"
                                      alt=""
                                    />
                                    <div className="avatar-name ml-10">
                                      <b>GIFT FRAME NAME </b>
                                      <div className="comments-date mb-10">
                                        <span>16"X20" | $72.00</span>
                                      </div>
                                      <p className="mb">
                                        Lorem ipsum dolor sit amet, consectetur
                                        adipiscing <br /> elit. Etiam ipsum
                                        ante, maximus in tempor eget.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xl-4 col-lg-12 col-12 tablet">
                                  <div className="comments-text">
                                    <div className="comments-top d-sm-flex align-items-center justify-content-between mb-5">
                                      <div className="user-rating">
                                        <a
                                          className="recover large head"
                                          href="#"
                                        >
                                          Reorder
                                        </a>
                                        <a
                                          className="delete large head"
                                          href="#"
                                        >
                                          Delete
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="basic-pagination">
                          <div className="left">
                            <a href=".html" className="left-text">
                              Rows per page:
                            </a>
                            <a href="blog.html" className="mr-30">
                              <b>8</b>
                              <i
                                className="fa fa-sort-desc"
                                aria-hidden="true"
                              />
                            </a>
                            <a href=".html" className="left-text mr-30">
                              1-8 of 1240
                            </a>
                            <a href className="mr-30">
                              <svg
                                width={44}
                                height={14}
                                viewBox="0 0 44 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7 13L1.07071 7.07071C1.03166 7.03166 1.03166 6.96834 1.07071 6.92929L7 1"
                                  stroke="#394252"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                />
                                <path
                                  d="M37 13L42.9293 7.07071C42.9683 7.03166 42.9683 6.96834 42.9293 6.92929L37 1"
                                  stroke="#394252"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade "
                      id="reviews"
                      role="tabpanel"
                      aria-labelledby="reviews-tab"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
